import {HStack, Icon, Input, InputGroup} from "@chakra-ui/react";
import {HiOutlineTrash} from "react-icons/hi2";
import {FiEdit} from "react-icons/fi";
import {useEffect, useRef, useState} from "react";

const ControlledInput = ({
  value,
  onChangeText,
  onTrashClick,
  onEditClick,
  placeholder,
  isDisabled,
  fieldId,
  canRemove = true,
}) => {
    const inputRef = useRef(null);
    
    const handleEditClick = () => {
        onEditClick && onEditClick(fieldId);
        inputRef.current?.focus();
    }

    const handleTrashClick = () => {
        onTrashClick && onTrashClick();
    }

    const handleOnChangeText = (value) => {
        onChangeText && onChangeText(value);
    }
    
    const inputActionButtons = (
        <HStack color={'white'}>
            {!isDisabled && canRemove &&
                <Icon variant={'hoverable'} fontSize={34} onClick={handleTrashClick}>
                    <HiOutlineTrash/>
                </Icon>
            }
            {isDisabled &&
                <Icon variant={'hoverable'} fontSize={34} onClick={handleEditClick} strokeWidth={1.5}>
                    <FiEdit/>
                </Icon>
            }
        </HStack>
    );
    
    return (
        <InputGroup endElement={inputActionButtons}
                    data-state={'open'}
                    _open={{animation: "fade-in 300ms ease-out"}}>
            <Input ref={inputRef} disabled={isDisabled} variant={'primary'} color={'white'} value={value} onChange={(e) => handleOnChangeText(e.target.value)} placeholder={placeholder}/>
        </InputGroup>
    )
}

export default ControlledInput;
